/**
 * chefUtils.js — chef-profile matching against the Square catalog (pure, with a
 * module-level catalog cache shared across the dashboard).
 */

let _sqCatalog = null;

export function getSqCatalog() { return _sqCatalog; }
export function setSqCatalog(c) { _sqCatalog = c; }

export function itemMatchesProfile(itemName, profile) {
  if (!profile || !profile.keywords || profile.keywords.length === 0) return false;
  const lower = (itemName || '').toLowerCase();
  return profile.keywords.some(kw => {
    if (!kw.trim()) return false;
    const kwl = kw.trim().toLowerCase();
    if (lower.includes(kwl)) return true;
    if (_sqCatalog) {
      const cat = _sqCatalog.find(c => c.name.toLowerCase() === kwl);
      if (cat) {
        return cat.items.some(ci => lower.includes(ci.toLowerCase()) || ci.toLowerCase().includes(lower));
      }
    }
    return false;
  });
}

export function getItemColorForProfile(itemName, profile) {
  if (!profile) return null;
  const fallback = profile.color;
  if (!profile.categoryColors || Object.keys(profile.categoryColors).length === 0) return fallback;
  if (!_sqCatalog) return fallback;
  const lower = (itemName || '').toLowerCase();
  const catKws = (profile.keywords || []).filter(kw => {
    const cat = _sqCatalog.find(c => c.name.toLowerCase() === kw.trim().toLowerCase());
    return !!cat;
  });
  for (const kw of catKws) {
    const cat = _sqCatalog.find(c => c.name.toLowerCase() === kw.trim().toLowerCase());
    if (cat && cat.items.some(ci => lower.includes(ci.toLowerCase()) || ci.toLowerCase().includes(lower))) {
      return profile.categoryColors[kw] || fallback;
    }
  }
  return fallback;
}

export function newProfileId() {
  return `cp_${Date.now()}_${Math.random().toString(36).slice(2, 5)}`;
}
